/**
 * URL de entrada na plataforma para quem acabou de comprar.
 *
 * O checkout roda num host próprio e o comprador é anônimo aqui: a sessão da
 * área de membros é cookie do domínio DA PLATAFORMA. A única ponte entre as
 * duas origens é o token do membro na URL — e quem sabe transformá-lo em
 * sessão é a tela de pagamento da plataforma (`/p/payment/:reference`), a
 * mesma entrada que o fluxo sem página de confirmação sempre usou: ela faz o
 * auto-login e segue para o obrigado, onde o comprador novo cria a senha.
 *
 * Sem isso o botão "Acessar a plataforma" entregava o comprador deslogado e
 * sem senha, dependendo só do e-mail.
 *
 * 🔒 Só serve para o destino PADRÃO (a própria plataforma). Nunca anexe o token
 * a um link configurado pelo admin: ele pode apontar para terceiros.
 */
export const platformEntryUrl = (
	platformUrl?: string | null,
	receipt?: string | null,
	accessToken?: string | null
): string | undefined => {
	if (!platformUrl) return undefined;
	if (!receipt || !accessToken) return platformUrl;

	try {
		const { origin, protocol } = new URL(platformUrl);
		if (protocol !== 'https:' && protocol !== 'http:') return platformUrl;

		const query = new URLSearchParams({ access_token: accessToken });
		return `${origin}/p/payment/${encodeURIComponent(
			receipt
		)}?${query.toString()}`;
	} catch {
		// URL da plataforma malformada: melhor o link cru que link nenhum.
		return platformUrl;
	}
};
